import React from 'react'
import PropTypes from 'prop-types'

import Typography from '../../../../components/common/Typography'
import { intlDateWithTimeFormat } from '../../../../utils/dateUtils'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { eventLogTypeLabel } from '../../../../constants/filter'

const Item = ({ item }) => {
  return (
    <TableRow>
      <TableCell align="left">
        <Typography variant="inherit" fontFamily="lexend">
          {intlDateWithTimeFormat(item.createdAt)}
        </Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant="inherit" fontFamily="lexend">
          {item?.user?.name} {item?.user?.familyName}
        </Typography>
      </TableCell>
      <TableCell align="left">
        <Typography variant="inherit" fontFamily="lexend">
          {eventLogTypeLabel(item.type)}
        </Typography>
      </TableCell>

      <TableCell align="left">
        <Typography variant="inherit" fontFamily="lexend">
          {item.description}
        </Typography>
      </TableCell>
    </TableRow>
  )
}

Item.propTypes = {
  item: PropTypes.shape({
    createdAt: PropTypes.string,
    user: PropTypes.shape({
      name: PropTypes.string,
      familyName: PropTypes.string,
    }),
    type: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
}

export default Item
